import React, { Component } from "react";
import BaseComponent from "../../BaseComponent.js";
import { Redirect } from "react-router";
import accountService from "../../../services/AccountService";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import { validateEmailFormat } from "../../Global/tools.js";

//Components
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import FormLogin from "../../Micro/FormLogin.js";
import Loading from "../../Nano/Loading.js";

//Images
import backgroundImage from "../../../images/bck-login.svg";
import logoNota from "../../../images/nota.svg";
import logoGlance from "../../../images/glance.svg";
import logoGlanceSimple from "../../../images/glance-simple.svg";

const multiple = nota.global.multiple;

const LoginBackgroundStyle = styled.div`
  //padding: 5%;
  //background-image: url(${backgroundImage});
  //background-repeat: no-repeat, repeat;
  //background-size: cover;
  height: 100%;
  width: 50%;

  .loginContainer {
    padding: 5%;
    padding-bottom: 0;
    background-image: url(${backgroundImage});
    background-repeat: no-repeat, repeat;
    background-size: cover;
  }

  .header-login {
    img {
      margin-bottom: ${multiple * 5 + "px"}; /*40px*/
    }
    .textWrapper {
      height: auto;
      h1 {
        text-transform: unset;
      }
    }

    @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
      img {
        width: 140px;
        margin-bottom: ${multiple * 3 + "px"}; /*24px*/
      }
      h1 {
        font-size: 15px;
        line-height: 25px;
        b {
          font-size: 20px;
        }
      }
    }
  }

  .footer-login {
    .completeLogo {
      width: 125px;
      margin: ${multiple * 3 + "px"}; /*24px*/
    }
    .simpleLogo {
      display: none;
      width: 56px;
      margin: 0;
    }
    .align-bottom {
      height: auto;
      margin: ${multiple * 2 + "px"}; /*16px*/
      text-align: center;

      @media only screen and (max-width: ${nota.global.breakpoints.desktop + "px"}) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: flex-start;
        p {
          &:after {
            display: none;
          }
        }
      }
      @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        p {
          font-size: 10px;
          line-height: 12px;
        }
      }
    }

    @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
      flex-direction: row;
      .logoWrapper {
        justify-content: flex-start;
        width: 20%;
        .completeLogo {
          display: none;
        }
        .simpleLogo {
          display: block;
        }
      }
      .align-bottom {
        text-align: left;
      }
    }
  }
  .footer-link {
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .responsiveLogin {
    display: none;
    margin: ${multiple * 3 + "px"}; /*24px*/
  }
  @media only screen and (max-width: ${nota.global.breakpoints.laptop + "px"}) {
    .secondLine {
      width: 70%;
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
    .secondLine {
      width: 75%;
    }
  }
  @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
    width: 100%;
    .loginContainer {
      height: auto;
      min-height: 100%;
    }
    .responsiveLogin {
      display: flex;
      .loginForm {
        .bckWrapper {
          .form-wrapper {
            width: 100%;
            //min-width: 315px;
          }
        }
      }
    }
  }
`;

const StyledWrapperLogin = styled(NanoFlex)`
  width: 50%;
  height: 100%;
  @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
    display: none;
  }
`;

const StyledLoginPage = styled(NanoFlex)`
  position: relative;
  height: 100vh;
`;

export class Login extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loginDisabled: false,
      error: null,
      redirectTo: "",
      forceLogin: false,
      modalOpen: false,
      checkboxFlagRememberMe: false,

      recoverPasswordVisible: false,
      recoverPasswordEmail: "",
      recoverPasswordEmailError: false,
      recoverPasswordStatus: null,
      recoverPasswordDisabled: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (accountService.getToken() !== null) {
      accountService.logOut().then((response) => {
        /*Remove User From LocalStorage */
        accountService.removeToken();
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.username !== this.state.username || prevState.password !== this.state.password) {
      this.setState({ error: null });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  usernameChange = (value) => {
    this.setState({ username: value });
  };

  passwordChange = (value) => {
    this.setState({ password: value });
  };

  loginSubmit = async (event) => {
    // Prevent page refresh
    event.preventDefault();
    await this.login();
  };

  login = async () => {
    await this.setState({ loginDisabled: true }, async () => {
      const response = await accountService.authenticate(this.state.username, this.state.password, this.state.checkboxFlagRememberMe, this.state.forceLogin);
      const data = await response.json();

      if (response.ok) {
        // Set User
        accountService.setToken(data);
        //Set Language
        window.dispatchEvent(new CustomEvent("languageChange", { detail: accountService.getUser().IdLanguage }));
        // Redirect to Homepage
        this.setState({ redirectTo: this.props?.location?.state?.from?.pathname ?? "/", error: null, loginDisabled: false });
      } else {
        // Catch Error
        this.setState({ error: data.message, forceLogin: data.isAlreadyLoggedIn, loginDisabled: false });
      }
    });
  };

  cancelForceLogin = () => {
    this.setState({ error: null, forceLogin: false });
  };

  recoverPasswordVisibleChange = (value) => {
    this.setState({ recoverPasswordVisible: value, recoverPasswordEmail: "", recoverPasswordStatus: null, recoverPasswordEmailError: false });
  };

  recoverPasswordEmailChange = (value) => {
    this.setState({ recoverPasswordEmail: value });
  };

  recoverPasswordSubmit = (event) => {
    // Prevent page refresh
    event.preventDefault();
    this.setState({ recoverPasswordDisabled: true }, () => {
      if (validateEmailFormat(this.state.recoverPasswordEmail)) {
        accountService
          .recoverPassword(this.state.recoverPasswordEmail)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              // Catch
              if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
            }
          })
          .then((data) => {
            this.setState({ recoverPasswordStatus: data ? true : false, recoverPasswordEmailError: data ? false : true, recoverPasswordDisabled: false });
          });
      } else {
        this.setState({ recoverPasswordEmailError: true, recoverPasswordDisabled: false });
      }
    });
  };

  render() {
    /*Redirect to Homepage After Login*/
    if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />;

    let formLogin = (
      <FormLogin
        loginDisabled={this.state.loginDisabled}
        loginSubmit={(e) => this.loginSubmit(e)}
        error={this.state.error !== null}
        username={this.state.username}
        password={this.state.password}
        onChangeActionUsername={(currentValue, id, title, type) => this.usernameChange(currentValue)}
        onChangeActionPassword={(currentValue, id, title, type) => this.passwordChange(currentValue)}
        toggleCheckBox={this.state.checkboxFlagRememberMe}
        onChangeActionRememberMe={(id, label) => this.setState({ checkboxFlagRememberMe: !this.state.checkboxFlagRememberMe })}
        showModal={this.state.forceLogin}
        cancelActionModal={this.cancelForceLogin}
        nextActionModal={this.login}
        recoverPasswordVisible={this.state.recoverPasswordVisible}
        onChangeActionRecoverPasswordVisible={(currentValue) => this.recoverPasswordVisibleChange(currentValue)}
        recoverPasswordEmail={this.state.recoverPasswordEmail}
        recoverPasswordEmailError={this.state.recoverPasswordEmailError}
        onChangeActionRecoverPasswordEmail={(currentValue) => this.recoverPasswordEmailChange(currentValue)}
        recoverPasswordStatus={this.state.recoverPasswordStatus}
        recoverPasswordSubmit={this.recoverPasswordSubmit}
        recoverPasswordDisabled={this.state.recoverPasswordDisabled}
      />
    );

    return (
      <StyledLoginPage>
        <NanoFlex className="loginPageWrapper" justifyContent={"space-between"}>
          <LoginBackgroundStyle>
            <NanoFlex className="loginContainer" flexDirection={"column"} justifyContent={"space-around"}>
              <NanoFlex className="header-login" flexDirection={"column"} alignItems={"flex-start"}>
                <img src={logoNota} alt="nota" />
                <NanoFlex className="textWrapper" justifyContent={"flex-start"}>
                  <Type.h1 white>Tracking new programmes</Type.h1>
                </NanoFlex>
                {/* <NanoFlex className="textWrapper" justifyContent={"flex-start"}>
                  <Type.h1 white>
                    <i>
                      <b>NEW PROGRAMMES,</b>
                    </i>
                  </Type.h1>
                </NanoFlex> */}
                <NanoFlex className="textWrapper" justifyContent={"flex-start"}>
                  <Type.h1 white className="secondLine">
                    launches & audiences. Globally
                  </Type.h1>
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="responsiveLogin">{formLogin}</NanoFlex>

              <NanoFlex className="footer-login" flexDirection={"column"} flexWrap={"warp"} alignItems={"center"} justifyContent={"center"}>
                <div className="logoWrapper">
                  <a href="https://www.glance-mediametrie.com/" rel="noopener noreferrer" target="_blank">
                    <img className="completeLogo" src={logoGlance} alt="glance" />
                    <img className="simpleLogo" src={logoGlanceSimple} alt="glance" />
                  </a>
                </div>

                <div className="align-bottom">
                  <Type.p white>Médiamétrie - Glance - All rights reserved © 2001-2025 E-Nota</Type.p>
                  <Type.p white>+331 710 006 50</Type.p>
                  <Type.p white>
                    <a className="footer-link" href="mailto:e-nota@glance-mediametrie.com">
                      e-nota@glance-mediametrie.com
                    </a>
                  </Type.p>
                  <Type.p white>
                    <a className="footer-link" href="https://www.mediametrie.fr/en/personal-data-mediametrie" rel="noopener noreferrer" target="_blank">
                      Privacy Policy
                    </a>
                  </Type.p>
                </div>
              </NanoFlex>
            </NanoFlex>
          </LoginBackgroundStyle>

          <StyledWrapperLogin>{formLogin}</StyledWrapperLogin>
        </NanoFlex>
      </StyledLoginPage>
    );
  }
}
